import cx from 'classnames';
import React from 'react';
import { CodeNameModel } from 'components/common/types';
import BaseSelect from 'lib/BaseSelect';
import { Padding } from 'lib/BaseSelect/BaseSelect.types';
import { PRIORITY_OPTIONS, PrioritySelectProps } from './PrioritySelect.types';

const PrioritySelect: React.FC<PrioritySelectProps> = ({
  selectedValue,
  onChange,
  name = 'priority-select',
  menuPlacement = 'auto',
  isDisabled = false,
}) => {
  return (
    <div className="w-full relative flex justify-between">
      <div className="w-20 relative flex-col items-center">
        <p className="body-md mb-1">Priority</p>
        <div
          className={cx({
            'w-20': !selectedValue,
          })}
        >
          <BaseSelect
            name={name}
            dataTestId={name}
            selectedValue={selectedValue}
            options={PRIORITY_OPTIONS}
            onSelect={(_, value: CodeNameModel) => onChange(value)}
            menuPlacement={menuPlacement}
            isPlaceholderVisible={false}
            padding={Padding.DEFAULT}
            maxMenuHeight={150}
            isDisabled={isDisabled}
          />
        </div>
      </div>
    </div>
  );
};

export default PrioritySelect;
